import type { AllRouteEndpoints } from "../routeTypes";

export const engagementAppGroupIdSuppressionRules = "/engagement/:app_group_id/suppression_rules";

export const postEngagementAppGroupIdSuppressionRulesCacheKeys: AllRouteEndpoints[] = [
  engagementAppGroupIdSuppressionRules,
];
